import landingImage from '../assets/images/landing.webp';
import knowMoreImage from '../assets/images/knowMore.webp';
import categoryImage from '../assets/images/AluminiumPackaging.webp';
import Franchise from '../assets/images/franchise.webp';
import Associate from '../assets/images/associate.webp';
import logo from '../assets/images/logo.webp';
import contactUsBg from '../assets/images/contactUsBg.webp';
import map from '../assets/images/map.webp';
import saveEnergy1 from '../assets/images/saveEnergy1.webp';
import saveEnergy2 from '../assets/images/saveEnergy2.webp';
import saveEnergy3 from '../assets/images/saveEnergy3.webp';
import saveEnergy4 from '../assets/images/saveEnergy4.webp';
import saveEnergy5 from '../assets/images/saveEnergy5.webp';
import saveEnergy6 from '../assets/images/saveEnergy6.webp';
import csrBg from '../assets/images/csrBg.webp';
import foundation1 from '../assets/images/foundation1.webp';
import foundation2 from '../assets/images/foundation2.webp';
import foundation3 from '../assets/images/foundation3.webp';
import shishImg1 from '../assets/images/shishImg1.webp';
import shishImg2 from '../assets/images/shishImg2.webp';
import shishImg3 from '../assets/images/shishImg3.webp';
import package1 from '../assets/images/industrialPackaging.webp';
import package2 from '../assets/images/PEWoven.webp';
import package3 from '../assets/images/thermal.webp';
import package4 from '../assets/images/consumer.webp';
import package5 from '../assets/images/paper.webp';
// import pdsStore from '../assets/images/inpackaging.png';
import shishcartStore from '../assets/images/shishcart.webp';
import innovationBg from '../assets/images/innovationBg.webp';
import lab from '../assets/images/lab.webp';
import close from '../assets/images/close.svg';
import hamburger from '../assets/images/hamburger-menu.svg';
import package0 from '../assets/images/package1.webp';
import ourSolution1 from '../assets/images/ourSolution1.webp';
import packageBg from '../assets/images/packageBg.webp';
import certificateBg from '../assets/images/certificateBg.webp';
import newsCard from '../assets/images/newsCard.webp';
import reportCard from '../assets/images/reportCard.webp';
import userImage from '../assets/images/userImage.webp';
import commaImage from '../assets/images/commaIcon.webp';
import contactusImage from '../assets/images/contactusImage.webp';
import aboutpageHeader from '../assets/images/aboutHeader.webp';
import groupImage from '../assets/images/Maskgroup.webp';
import rameshbhaiImage from '../assets/images/rameshbhai.webp';
import satishbhaiImage from '../assets/images/satishbhai.webp';
import missionImage from '../assets/images/mission.webp';
import bgStrength from '../assets/images/bgStrength.webp';
import stengthCard1 from '../assets/images/reliability.webp';
import stengthCard2 from '../assets/images/innovation.webp';
import stengthCard3 from '../assets/images/Sustainability.webp';
import stengthCard4 from '../assets/images/customer.webp';
import careerHeader from '../assets/images/careerheader.webp';
import career1 from '../assets/images/career1.webp';
import career2 from '../assets/images/career2.webp';
import career3 from '../assets/images/career3.webp';
import career4 from '../assets/images/career4.webp';
import career5 from '../assets/images/career5.webp';
import career6 from '../assets/images/career6.webp';
import financial from '../assets/images/financial.webp';
import downloadPdf from '../assets/images/downloadPdf.webp';
import case1 from '../assets/images/case1.webp';
import case2 from '../assets/images/case2.webp';
import case3 from '../assets/images/case3.webp';
import caseArc1 from '../assets/images/caseArc1.webp';
import caseArc2 from '../assets/images/caseArc2.webp';
import shippingDummyImg from '../assets/images/shippingDummyImg.webp';
import product1 from '../assets/images/product1.webp';
import product2 from '../assets/images/product2.webp';
import packagingStep from '../assets/images/packagingStep.webp';
import shish360 from '../assets/images/shish360.webp';
import imagePackaging1 from '../assets/images/expertise.webp';
import imagePackaging2 from '../assets/images/agile.webp';
import imagePackaging3 from '../assets/images/focus.webp';
import imagePackaging4 from '../assets/images/continuous-improvementq.webp';
import imagePackaging5 from '../assets/images/profitw.webp';
import imagePackaging6 from '../assets/images/problem-solvingq.webp';
import center360 from '../assets/images/center260.webp';
import mediaBg from '../assets/images/mediaBg.webp';
import investorBg from '../assets/images/investorBg.webp';
import research1 from '../assets/images/research1.webp';
import research2 from '../assets/images/research2.webp';
import research3 from '../assets/images/research3.webp';
import research4 from '../assets/images/research4.webp';
import packagingProductsbg from '../assets/images/bgPackagingProducts.webp';
import downloadPdf2 from '../assets/images/downloadPdf2.webp';
import packagingBg from '../assets/images/packagingBg.webp';
import shippingBg from '../assets/images/shippingBg.webp';
import callIcon from '../assets/images/callIcon.webp';
import mailIcon from '../assets/images/mailIcon.webp';
import locationIcon from '../assets/images/locationIcon.webp';
import websiteIcon from '../assets/images/websiteIcon.webp';
import protection from '../assets/images/protection.webp';
import containers from '../assets/images/containers.webp';
import pallet from '../assets/images/pallet.webp';
import bulk from '../assets/images/bulk.webp';
import steelCoil from '../assets/images/steelCoil.webp';
import palletCover from '../assets/images/palletCover.webp';
import headertagBg from '../assets/images/headerTagbg.webp';
import img101 from '../assets/images/data101.webp';
import img1011 from '../assets/images/img1011.webp';
import img102 from '../assets/images/img102.webp';
import img103 from '../assets/images/img103.webp';
import img104 from '../assets/images/img104.webp';
import img105 from '../assets/images/img105.webp';
import img106 from '../assets/images/img106.webp';
import img107 from '../assets/images/img107.webp';
import img201 from '../assets/images/img201.webp';
import img202 from '../assets/images/img202.webp';
import img203 from '../assets/images/img203.webp';
import img204 from '../assets/images/img204.webp';
import img205 from '../assets/images/img205.webp';
import img206 from '../assets/images/img206.webp';
import img207 from '../assets/images/img207.webp';
import img208 from '../assets/images/img208.webp';
import img209 from '../assets/images/img209.webp';
import img301 from '../assets/images/img301.webp';
import img302 from '../assets/images/img302.webp';
import img303 from '../assets/images/img303.webp';
import FIBCimg from '../assets/images/FIBCimg.webp';
import linkedIn from '../assets/images/linkedin.png';
import fb from '../assets/images/fb.png';
import insta from '../assets/images/insta.png';
import youtube from '../assets/images/youtube.webp';
import mediaImage1 from '../assets/images/image 26.webp';
import mediaImage2 from '../assets/images/image 27.webp';
import mediaImage3 from '../assets/images/image 28.webp';
import mediaImage4 from '../assets/images/image 29.webp';
import mediaImage5 from '../assets/images/image 30.webp';
import mediaImage6 from '../assets/images/image 34.webp';
import mediaImage7 from '../assets/images/Group 35.webp';
import mediaImage8 from '../assets/images/media-image-business-people-using-internet.jpg';
import mediaImage9 from '../assets/images/media-image-business-startup-works-digital-online-infomation.jpg';
import mediaImage10 from '../assets/images/media-image-businessman-analyzing-growth-chart-office.jpg';
import mediaImage11 from '../assets/images/media-image-businessman-drawing-red-line.jpg';
import mediaImage12 from '../assets/images/media-image-businessman-shaking-hands-with-client.jpg';
import mediaImage13 from '../assets/images/media-image-close-up-executive-with-coffee-newspaper.jpg';
import mediaImage14 from '../assets/images/media-image-close-up-hand-holding-smartphone.jpg';
import mediaImage15 from '../assets/images/media-image-close-up-hands-business-concept.jpg';
import mediaImage16 from '../assets/images/media-image-corporate-business-handshake-business-partners.jpg';
import mediaImage17 from '../assets/images/media-image-corporate-businessmen-working-tablet-office.jpg';
import mediaImage18 from '../assets/images/media-image-hand-holding-growth-arrow-with-coins.jpg';
import mediaImage19 from '../assets/images/media-image-low-angle-view-skyscrapers.jpg';
import mediaImage20 from '../assets/images/media-image-team-work-process-young-business-managers-crew-working-with-new-startup-project-labtop-wood-table-typing-keyboard-texting-message-analyse-graph-plans.jpg';
import mediaImage21 from '../assets/images/media-image-workers-examining-graphics.jpg';
import mapImage1 from '../assets/images/Clip-path-group1.webp';
import mapImage2 from '../assets/images/Clip-path-group2.webp';
import mapImage3 from '../assets/images/Clip-path-group3.webp';
import mapImage4 from '../assets/images/Clip-path-group4.webp';
import reportImg1 from '../assets/images/image 35.webp';
import reportImg2 from '../assets/images/image 36.webp';
import reportImg3 from '../assets/images/image 37.webp';
import reportImg4 from '../assets/images/image 38.webp';
import reportImg5 from '../assets/images/image 39.webp';
import reportImg6 from '../assets/images/image 40.webp';
import reportImg7 from '../assets/images/image 41 (1).webp';
import downloadImg1 from '../assets/images/arrow-download.webp';
import downloadImg2 from '../assets/images/downloadw.webp';
import productCategoryBg from '../assets/images/productCategoryBg.webp';
import category_bottle_icon from '../assets/images/category_bottle_icon.webp';
import paparPackaging from '../assets/images/PaperPackaging.jpg';
import aniImage from '../assets/images/ani_logo-white.png';
import Mumbai_News_Express_ from '../assets/images/Mumbai_News_Express_.png';
import web_india from '../assets/images/web_india.png';
import bignewsnetwork from '../assets/images/big-news-network.png';
import business from '../assets/images/business.png';
import lastly from '../assets/images/lastly.png';
import SME from '../assets/images/SME.webp';
import indiaeducationdiarylogo from '../assets/images/indiaeducationdiarylogo_header.png';
import lokmat from '../assets/images/lokmat.png';
import andhram from '../assets/images/andhram.png';
import indiagreat from '../assets/images/indiagreat.png';
import business_micro from '../assets/images/business_micro.png';
import hello_ent from '../assets/images/hello_ent.png';
import userBlue from '../assets/images/userBlue.png';
import aboutusBG from '../assets/images/bg-aboutus.png';
import endtoendbg from '../assets/images/Endtoend_bg.png';
import investorbg from '../assets/images/investor-bg.png';
import ani_media from '../assets/images/ani_media.png';
import bg_product from '../assets/images/bg-product.png';
import ourSolution2 from '../assets/images/ourSolution2.png';
import linkedinFooter from '../assets/images/linkedinFooter.png';
import fbFooter from '../assets/images/fbFooter.png';
import instaFooter from '../assets/images/instaFooter.png';
import featureImg2 from '../assets/images/featureImg2.png';
import featureImg3 from '../assets/images/featureImg3.png';
import featureImg4 from '../assets/images/featureImg4.png';
import featureImg5 from '../assets/images/featureImg5.png';
import featureImg6 from '../assets/images/featureImg6.png';
import threeStepbg from '../assets/images/threeStepbg.png';
import pagenotfound from '../assets/images/pagenotfound.png';
import all_pack_sol from '../assets/images/360_group.png';
import all_sol from '../assets/images/360_sol.png';
import digitaljournal from '../assets/images/Digital-Journal-logo.jpg';
import worldpoPulationReview from '../assets/images/World Population Review.png';
import youTubeLogo from '../assets/images/youtube-svgrepo-com 1.png';
import wrappFreshFoofPackaging from '../assets/images/wrappFreshFoofPackaging.png';
import thermalInsulationsUpdated from '../assets/images/thermalInsulationsUpdated.png';
import industrialPackagingUpdated from '../assets/images/industrialPackagingUpdated.png';
import eventsBanner from '../assets/images/eventsBanner.png';
import ppBubbleRoll from '../assets/images/ppBubbleRoll.png';
import IPImage from '../assets/images/IPImage.png';
import ThankYouImg from '../assets/images/thank-you.png';
import backArrow from '../assets/images/arrow-circle-right.png';
import cs1 from '../assets/images/cs1.png';
import cs2 from '../assets/images/cs2.png';
import cs3 from '../assets/images/cs3.png';
import automotive1 from '../assets/images/automotive1.png';
import automotive2 from '../assets/images/automotive2.png';
import automotive3 from '../assets/images/automotive3.png';
import domestic1 from '../assets/images/domestic1.png';
import domestic2 from '../assets/images/domestic2.png';
import glassIndustry1 from '../assets/images/glassIndustry1.png';
import glassIndustry2 from '../assets/images/glassIndustry2.png';
import stickNtouch from '../assets/images/stick-n-touch.png';
import sticklogo from '../assets/images/stick_logo.png';
import bagInBox from '../assets/images/bag_In_box.jpg';
import liquidBox from '../assets/images/liqid_bag_1.png';
import shishFooterLogo from '../assets/images/SHISH_Footer.png';
import downloadVideo from '../assets/images/downloadVideo.png';
import mp4videoImage from '../assets/images/mp4videoImage.png';
import downloadPDFNew from '../assets/images/download_pdf_new.png';
import industrial_packaging from '../assets/images/industrial_packaging.jpg';
import electronics_service from '../assets/images/electronics_service.jpg';
import pharmaceutical_service from '../assets/images/pharmaceutical_service.jpg';
import food_service from '../assets/images/food_service.jpg';
import retail_service from '../assets/images/retail_service.jpg';
import logistics_service from '../assets/images/logistics_service.jpg';
import automotive_service from '../assets/images/automotive_service.jpg';
import agriculture_service from '../assets/images/agriculture_service.jpg';
import construction_service from '../assets/images/construction_service.jpg';
import us_flag from '../assets/images/us_flag.jpeg';
import indian_flag from '../assets/images/inadian_flag.png';
import bcpback from '../assets/images/bcpback.jpeg';
import noProfile from '../assets/images/no_profile.png';
import bcpLogo from '../assets/images/logo192.jpeg';
import sunny from '../assets/images/sunny.jpeg';
import parth from '../assets/images/parth.png';
import chris from '../assets/images/chris.jpeg';
//chris.jpeg
// logo192.jpeg
// sunny.jpeg
// us_flag.jpeg
const Images = {
  aboutusBG,
  bg_product,
  linkedinFooter,
  fbFooter,
  threeStepbg,
  featureImg2,
  featureImg3,
  featureImg4,
  featureImg5,
  featureImg6,
  instaFooter,
  ani_media,
  endtoendbg,
  investorbg,
  landingImage,
  lokmat,
  fbFooter,
  instaFooter,
  linkedinFooter,
  andhram,
  indiagreat,
  business_micro,
  hello_ent,
  aniImage,
  web_india,
  bignewsnetwork,
  lastly,
  SME,
  indiaeducationdiarylogo,
  business,
  Mumbai_News_Express_,
  knowMoreImage,
  catImage1: categoryImage,
  Franchise,
  Associate,
  logo,
  contactUsBg,
  pagenotfound,
  map,
  saveEnergy1,
  saveEnergy2,
  saveEnergy3,
  saveEnergy4,
  saveEnergy5,
  saveEnergy6,
  csrBg,
  foundation1,
  foundation2,
  foundation3,
  shishImg1,
  shishImg2,
  shishImg3,
  package1,
  package2,
  package3,
  package4,
  package5,
  // pdsStore,
  shishcartStore,
  innovationBg,
  lab,
  close,
  hamburger,
  package0,
  ourSolution1,
  ourSolution2,
  packageBg,
  certificateBg,
  newsCard,
  reportCard,
  userImage,
  commaImage,
  contactusImage,
  aboutpageHeader,
  groupImage,
  rameshbhaiImage,
  satishbhaiImage,
  missionImage,
  bgStrength,
  stengthCard1,
  stengthCard2,
  stengthCard3,
  stengthCard4,
  careerHeader,
  career1,
  career2,
  career3,
  career4,
  career5,
  career6,
  financial,
  downloadPdf,
  downloadPdf2,
  case1,
  case2,
  case3,
  caseArc1,
  caseArc2,
  shippingDummyImg,
  product1,
  product2,
  packagingStep,
  shish360,
  imagePackaging1,
  imagePackaging2,
  imagePackaging3,
  imagePackaging4,
  imagePackaging5,
  imagePackaging6,
  center360,
  mediaBg,
  investorBg,
  research1,
  research2,
  research3,
  research4,
  packagingProductsbg,
  packagingBg,
  shippingBg,
  callIcon,
  mailIcon,
  locationIcon,
  websiteIcon,
  protection,
  containers,
  pallet,
  bulk,
  steelCoil,
  palletCover,
  headertagBg,
  img101,
  img1011,
  img102,
  img103,
  img104,
  img105,
  img106,
  img107,
  img201,
  img202,
  img203,
  img204,
  img205,
  img206,
  img207,
  img208,
  img209,
  img301,
  img302,
  img303,
  FIBCimg,
  linkedIn,
  fb,
  insta,
  mediaImage1,
  mediaImage2,
  mediaImage3,
  mediaImage4,
  mediaImage5,
  mediaImage6,
  mediaImage7,
  mediaImage8,
  mediaImage9,
  mediaImage10,
  mediaImage11,
  mediaImage12,
  mediaImage13,
  mediaImage14,
  mediaImage15,
  mediaImage16,
  mediaImage17,
  mediaImage18,
  mediaImage19,
  mediaImage20,
  mediaImage21,
  mapImage1,
  mapImage2,
  mapImage3,
  mapImage4,
  youtube,
  reportImg1,
  reportImg2,
  reportImg3,
  reportImg4,
  reportImg5,
  reportImg6,
  reportImg7,
  downloadImg1,
  downloadImg2,
  productCategoryBg,
  category_bottle_icon,
  paparPackaging,
  userBlue,
  all_pack_sol,
  all_sol,
  digitaljournal,
  worldpoPulationReview,
  youTubeLogo,
  wrappFreshFoofPackaging,
  thermalInsulationsUpdated,
  industrialPackagingUpdated,
  eventsBanner,
  ppBubbleRoll,
  IPImage,
  ThankYouImg,
  backArrow,
  cs1,
  cs2,
  cs3,
  automotive1,
  automotive2,
  automotive3,
  domestic1,
  domestic2,
  glassIndustry1,
  glassIndustry2,
  stickNtouch,
  sticklogo,
  bagInBox,
  liquidBox,
  shishFooterLogo,
  downloadVideo,
  mp4videoImage,
  downloadPDFNew,
  industrialPackaging: industrial_packaging,
  electronics_service,
  pharmaceutical_service,
  food_service,
  retail_service,
  logistics_service,
  automotive_service,
  agriculture_service,
  construction_service,
  us_flag,
  indian_flag,
  bcpback,
  noProfile,
  bcpLogo,
  sunny,
  parth,
  chris,
};

export default Images;
